import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../App.css';
import './services.css';
import { Link } from 'react-router-dom'; 
import Sidebar from '../../Sidebar';
import Seo from "../../Seo";


function PC_app(){
    const [items, setItems] = useState([]);

    useEffect(() => {
      axios.get('/backend/home.php', {
        headers: {
            'Custom-type': 'service1',
            'Content-Type': 'application/json',  // Beispiel für Content-Type
            // Weitere Header können hier hinzugefügt werden
        }
    })
    .then(response => {
        setItems(response.data);
    })
    .catch(error => {
        console.error('Es gab einen Fehler beim Abrufen der Daten:', error);
    });
    
    }
    , []);// Leer, d.h. dieser Effekt wird nur einmal nach dem initialen Rendern ausgeführt

    useEffect(() => {
        LanguageChange();
      }, [items]);// Dieser Effekt wird nur ausgeführt, wenn sich `items` ändert
    
      const LanguageChange = () => {
        if (items.length > 0) {
          const languageIndex = sessionStorage.getItem("language_index");
          const isEnglish = languageIndex != null && languageIndex == 1;
          
          const texts = ["text1", "e_text1", "e_text2", "e_text3","e_text4","text2","r_text1","r_text2","r_text3","r_text4","r_text5"];
          const topics = ["topic1","e_topic1","e_topic2","e_topic3","e_topic4","topic2","r_topic1","r_topic2","r_topic3","r_topic4","r_topic5"];
          document.getElementById('topic_header').innerText= isEnglish ? "Customised software solutions" : "Individuelle Softwarelösungen";
            document.getElementById('link').innerText= isEnglish ? " Please contact me" : " Kontaktieren Sie mich";
         
          document.getElementById('text_header').innerText=isEnglish ? "I offer customized application software solutions that meet your specific digital goals and requirements.":"Ich biete maßgeschneiderte Anwendungssoftwarelösungen an, die Ihre spezifischen digitalen Ziele und Anforderungen erfüllen.";
          texts.forEach((id, index) => {
            const element = document.getElementById(id);
            const topic_element = document.getElementById(topics[index]);
            if (element && items[index]) {
              element.innerHTML = isEnglish ? items[index].en_text : items[index].de_text;
            }
            if(topic_element){
                topic_element.innerHTML = isEnglish ? items[index].en_topic : items[index].de_topic;
            }
          });
        } else {
          document.getElementById('text1').innerHTML = "Ich entwickle individuelle Anwendungssoftware für kleine Unternehmen. Ob Arbeits- und Zeitmanagement, Kundendaten- und Terminverwaltung oder Mitarbeiterorganisation – meine Lösungen helfen, Abläufe zu vereinfachen und effizienter zu gestalten. So können Sie sich auf das Wesentliche konzentrieren: Ihr Geschäft.";
        }
      };
    
    return(
      <>
              <Seo
  title="Softwareentwicklung – Mobile & Desktop | Finn Mikoschek"
  description="Individuelle Softwareentwicklung für Unternehmen: Plattformübergreifende Apps für Mobile und Desktop (Windows, macOS, Web). Konzeption, Entwicklung und Betreuung."
/>
        <div><Sidebar onLanguageChange={LanguageChange}/>
        <div class="App-header">
            <div class="img_header"><h1 id='topic_header'>Individuelle Softwarelösungen</h1>
            <p id='text_header'></p>
            <img src="/images/web_app_header.webp"></img></div>
            <div class="text_container" id="service-container">
            <div class="text_container_data">
               
            
        <div class='enumeration' id='service_enumeration'>
         
          <h3 id="topic1">Mögliche Softwarelösungen für ihr Klein-Unternehmen</h3>
            <a id="text1">Loading...</a>
        <div class='feature_row' >
            <div class="service_item">
              <img src="/images/services_a1.webp"></img>
              <h4 id="e_topic1"></h4>
              <a id="e_text1">Ich entwickle für Sie ein System, mit dem Sie Aufgaben planen, organisieren und priorisieren können – genau so, wie es zu Ihrem Arbeitsalltag passt.</a>
            
            </div>
            <div class="service_item">
              <img src="/images/services_a2.webp"></img>
               <h4 id="e_topic2">Terminplanung</h4>
               <a id="e_text2">Ob Kundentermine oder Team-Meetings: Ich baue Ihnen eine Lösung, die Ihre Abläufe unterstützt und bei Bedarf Erinnerungen integriert.</a>
            </div>
              <div class="service_item">
              <img src="/images/services_a3.webp"></img>
               <h4 id="e_topic3">Kundendatenverwaltung</h4>
               <a id="e_text3">Ihre Kundendaten werden zentral, sicher und übersichtlich verwaltet. Ich passe die Struktur an Ihre Geschäftsprozesse an.</a>
            </div>
                    <div class="service_item">
              <img src="/images/workerssoftware.webp"></img>
               <h4 id="e_topic4">Mitarbeiterverwaltung</h4>
               <a id="e_text4">Von Mitarbeiterprofilen bis zur Zeiterfassung – ich entwickle Funktionen, die optimal zu Ihrem Team und Ihren Anforderungen passen.</a>
              
            </div>
            </div>
               <div className='Spacer'></div>
               <h3 id="topic2">Meine Software – Effizient, Sicher, Plattformübergreifend</h3>
               <a id="text2">Entdecken Sie, wie meine Software Ihr Unternehmen unterstützt: sichere Cloud-Speicherung, intuitive Bedienung auf allen Geräten, automatisierte Prozesse, flexible Berechtigungen und skalierbare Lösungen für jedes Team. <Link to="/contact" id="link" >Kontaktieren Sie mich</Link></a>
              
             <div class='feature_row' id="features">
                <div className="service_item">
              <img src="/images/cloud.webp"></img>
               <h4 id="r_topic1">Sichere Daten-Speicherung</h4>
               <a id="r_text1">Ihre Daten werden verschlüsselt in der Cloud gespeichert – jederzeit sicher und verfügbar.</a>
            </div>
              <div className="service_item">
              <img src="/images/plattformubergreifend.webp"></img>
               <h4 id="r_topic2">Plattformübergreifend</h4>
               <a id="r_text2">Greifen Sie von Desktop, Tablet oder Smartphone auf Ihre Software zu – immer synchron.</a>
            </div>
             <div className="service_item">
              <img src="/images/protection.webp"></img>
               <h4 id="r_topic3">Sicherheits & Berechtigungsmanagement</h4>
               <a id="r_text3">Verschiedene Rollen, Zugriffsbeschränkungen und sichere Authentifizierung für Ihr Team.</a>
            </div>
                      <div className="service_item">
              <img src="/images/ui.webp"></img>
               <h4 id="r_topic4">Benutzerfreundliches Dashboard</h4>
               <a id="r_text4">Dashboard Alle wichtigen Daten auf einen Blick – intuitiv bedienbar auf allen Geräten.</a>
            </div>
                      <div className="service_item">
              <img src="/images/growth.webp"></img>
               <h4 id="r_topic5">Skalierbar</h4>
               <a id="r_text5">Die Software wächst mit Ihrem Unternehmen – egal, ob ein Teammitglied oder 100 Mitarbeitende.</a>
            </div>
             </div>

      </div>
      </div>
                </div>
            
            </div>
        </div>
</>
    );

    

}

export default PC_app;